import { IOrder } from '@/interfaces/order';
import {
  generateQRString,
  groupByProduct,
  IQRProductGroup,
} from '@/utils/productQrCodeUtils';
import { QRCode } from 'antd';
import React from 'react';

interface IProps {
  data: IOrder;
}

const TemplateOrderInfoItemProductQr = ({ data }: IProps) => {
  const groupedProducts = groupByProduct(data?.orderItems || []);
  return (
    <div
      className="grid grid-cols-3 gap-y-[1cm] gap-x-0 mt-5"
      style={{ justifyItems: 'center' }}
    >
      {groupedProducts.map((prod: IQRProductGroup, idx: number) => {
        const qr = generateQRString(
          {
            documentNo: data.code,
            packingSize: prod.packSize,
            producerName: prod.productName,
            supplierName: 'Kemin',
          },
          prod,
        );
        console.log(qr);
        return (
          <div key={idx} className="flex justify-center">
            <QRCode value={qr} size={100} bordered={false} />
          </div>
        );
      })}
    </div>
  );
};

export default TemplateOrderInfoItemProductQr;
